if (!customElements.get('wls-collection-filters')) {
  class WLSCollectionFilters extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        active: 'active',
        filterMenuTrigger: 'js-wls-collection-filter-menu-trigger',
        filterMenu: 'js-wls-collection-filter-menu ',
      };

      this.selectors = {
        filterMenuTriggers: this.querySelectorAll(`.${this.classes.filterMenuTrigger}`),
        filterMenu: this.querySelector(`.${this.classes.filterMenu}`),
      };

      // Bind methods to preserve context
      this.handleKeyDown = this.handleKeyDown.bind(this);
      this.initDispatchCustomEvent = this.initDispatchCustomEvent.bind(this);
      this.toggleActiveClass = this.toggleActiveClass.bind(this);
    }

    /**
     * Lifecycle method called when the element is added to the DOM.
     * It sets up event listeners for each tag to handle tag selection.
     * @returns {void}
     */
    connectedCallback() {
      document.addEventListener('update-collection-filters', this.initDispatchCustomEvent);
      document.addEventListener('keydown', this.handleKeyDown);
      this.initFilters();
    }

    /**
     * Lifecycle method called when the element is removed from the DOM.
     * It removes all event listeners to prevent memory leaks.
     * @returns {void}
     */
    disconnectedCallback() {
      document.removeEventListener('update-collection-filters', this.initDispatchCustomEvent);
      document.removeEventListener('keydown', this.handleKeyDown);
      this.removeFilterListeners();
    }

    /**
     * Dispatches an event to initialize the filters when the collection filters are updated.
     * @returns {void}
     */
    initDispatchCustomEvent() {
      this.initFilters();
    }

    /**
     * Initializes the filter menu triggers by adding click event listeners to each trigger.
     * @returns {void}
     */
    initFilters() {
      this.removeFilterListeners(); // Remove existing listeners before adding new ones
      this.selectors.filterMenuTriggers.forEach((trigger) => {
        trigger.addEventListener('click', this.toggleActiveClass);
      });
    }

    /**
     * Removes click event listeners from filter menu triggers.
     * @returns {void}
     */
    removeFilterListeners() {
      this.selectors.filterMenuTriggers.forEach((trigger) => {
        trigger.removeEventListener('click', this.toggleActiveClass);
      });
    }

    /**
     * Toggles the active class on the filter menu trigger element.
     * Dispatches a custom event to clear filters not in the URL when closing the menu.
     * @returns {void}
     */
    toggleActiveClass() {
      const isActive = this.classList.toggle(this.classes.active);
      this.selectors.filterMenuTriggers.forEach((trigger) => {
        trigger.setAttribute('aria-expanded', isActive);
      });
    }

    /**
     * Handles the keydown event to close the filter menu when the Escape key is pressed.
     * @param {KeyboardEvent} event - The keyboard event.
     * @returns {void}
     */
    handleKeyDown(event) {
      if (event.key === 'Escape' && this.classList.contains(this.classes.active)) {
        this.toggleActiveClass();
      }
    }

    /**
     * Dispatches a custom event with the given name.
     * @param {string} eventName - The name of the event to dispatch.
     */
    dispatchCustomEvent(eventName) {
      const event = new CustomEvent(eventName, { bubbles: true, composed: true });
      this.dispatchEvent(event);
    }
  }

  window.customElements.define('wls-collection-filters', WLSCollectionFilters);
}
